export const widgetStyleConfig = {
  chsmeo_traffic_light_count: {
    icons: {
      default: "traffic-lights"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      inactive: "#999999",
      default: "#59D64E"
    }
  },
  tagil_traffic_light_count: {
    icons: {
      default: "traffic-lights"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      inactive: "#999999",
      default: "#59D64E"
    }
  },
  chsmeo_meteo_data_count: {
    icons: {
      default: "meteostation"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      default: "#59D64E"
    }
  },
  "chsmeo_pdk_cams_count?format=from_service": {
    icons: {
      default: "camera"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      default: "#59D64E"
    }
  },
  "chsmeo_cams_kps?format=count_from_service": {
    icons: {
      default: "camera"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      default: "#59D64E"
    }
  },
  "chsmeo_cams?format=stat": {
    icons: {
      default: "camera"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      inactive: "#999999",
      default: "#59D64E"
    }
  },
  "chsmeo_wialon_tracks?format=stat": {
    icons: {
      default: "bulldozer-2"
    },
    colors: {
      stroimekhanizatsiya: "#e41a1c",
      stroytech: "#377eb8",
      ural_syberian_company: "#4daf4a",
      stroi_servis: "#a65628",
      default: "#59D64E"
    }
  },
  chsmeo_tlt7_count: {
    icons: {
      default: "tlt7"
    },
    colors: {
      default: "rgb(255, 113, 0)"
    }
  },
  chsmeo_ngpt_count: {
    icons: {
      bus: "bus",
      trolleybus: "trolleybus",
      mtaxi: "mtaxi",
      tram: "tram",
      default: "bus"
    },
    colors: {
      bus: "#59D64E",
      trolleybus: "#2e93fe",
      mtaxi: "#B33EA9",
      tram: "#ffac00",
      default: "#59D64E"
    }
  },
  "TagilPublicTransport?format=vehicles_stats": {
    icons: {
      Автобус: "bus",
      Трамвай: "tram",
      default: "bus"
    },
    colors: {
      Автобус: "#59D64E",
      Трамвай: "#ffac00",
      default: "#59D64E"
    }
  },
  "TagilPublicTransport?format=stops_stats": {
    icons: {
      Автобусы: "bus",
      Трамвай: "tram",
      default: "bus"
    },
    colors: {
      Автобусы: "#59D64E",
      Трамвай: "#ffac00",
      default: "#59D64E"
    }
  },
  "TagilPublicTransport?format=stops": {
    icons: {
      active: "busActive",
      default: "mtaxi"
    },
    colors: {
      default: "#2e93fe"
    },
    fields: {
      name: "name"
    }
  },
  "TagilPublicTransport?format=dit": {
    icons: {
      active: "busActive",
      default: "mtaxi"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      default: "#59D64E"
    },
    fields: {
      status: "is_active",
      name: "name"
    }
  },
  "TagilPublicTransport?format=dit_stats": {
    icons: {
      default: "mtaxi"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      inactive: "#999999",
      default: "#59D64E"
    }
  },
  "TagilPublicTransport?format=routes_stats": {
    icons: {
      Автобусы: "bus",
      Трамвай: "tram",
      default: "bus"
    },
    colors: {
      Автобусы: "#59D64E",
      Трамвай: "#ffac00",
      default: "#59D64E"
    }
  },
  "event_stat/50833943-87c3-4104-a155-e8ed855445ac": {
    icons: {
      accident: "road-accident",
      road_works: "road-work",
      events: "road-event",
      default: "bus"
    },
    colors: {
      accident: "#FF3E3E",
      road_works: "#ffa931",
      events: "#ffee00",
      default: "#FF3E3E"
    }
  },
  "event_stat/6d8cc463-bff6-4f00-a40b-796324cb5308": {
    icons: {
      accident: "road-accident",
      road_works: "road-work",
      events: "road-event",
      default: "bus"
    },
    colors: {
      accident: "#FF3E3E",
      road_works: "#ffa931",
      events: "#ffee00",
      default: "#FF3E3E"
    }
  },
  "event_stat/831e5617-9a7b-47d8-87c6-682f71589696": {
    icons: {
      accident: "road-accident",
      road_works: "road-work",
      events: "road-event",
      default: "bus"
    },
    colors: {
      accident: "#FF3E3E",
      road_works: "#ffa931",
      events: "#ffee00",
      default: "#FF3E3E"
    }
  },
  "event_stat/34e633b0-178e-4aac-9209-639b9169dc81": {
    icons: {
      accident: "road-accident",
      road_works: "road-work",
      events: "road-event",
      default: "bus"
    },
    colors: {
      accident: "#FF3E3E",
      road_works: "#ffa931",
      events: "#ffee00",
      default: "#FF3E3E"
    }
  },
  "event_stat/8a87207b-c0a4-43ac-97fd-a9b83db5f961": {
    icons: {
      accident: "road-accident",
      road_works: "road-work",
      events: "road-event",
      default: "bus"
    },
    colors: {
      accident: "#FF3E3E",
      road_works: "#ffa931",
      events: "#ffee00",
      default: "#FF3E3E"
    }
  },
  "event_stat/4f2a0a86-2ab0-4e22-bee0-7e5be31eb771": {
    icons: {
      accident: "road-accident",
      road_works: "road-work",
      events: "road-event",
      default: "bus"
    },
    colors: {
      accident: "#FF3E3E",
      road_works: "#ffa931",
      events: "#ffee00",
      default: "#FF3E3E"
    }
  },
  events_log: {
    icons: {
      ДТП: "road-accident",
      "Ремонтные работы": "road-work",
      Мероприятия: "road-event",
      default: "s-center-editor"
    },
    colors: {
      ДТП: "#FF3E3E",
      "Ремонтные работы": "#ffa931",
      Мероприятия: "#ffee00",
      default: "#FF3E3E"
    }
  },
  "chsmeo_meteo_data?format=from_service": {
    icons: {
      active: "meteostationActive",
      default: "meteostation"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      default: "#59D64E"
    },
    fields: {
      location: "name",
      status: "status"
    }
  },
  chsmeo_traffic_light: {
    icons: {
      active: "trafficLightsActive",
      default: "traffic-lights"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      inactive: "#999999",
      default: "#59D64E"
    },
    fields: {
      location: "name",
      mode: "mode",
      status: "status"
    }
  },
  "tagil_traffic_light?format=from_service": {
    icons: {
      active: "trafficLightsActive",
      default: "traffic-lights"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      inactive: "#999999",
      default: "#59D64E"
    },
    fields: {
      location: "name",
      mode: "mode",
      status: "status"
    }
  },
  chsmeo_ngpt: {
    icons: {
      1: "trolleybus",
      2: "busGreen",
      3: "tram",
      4: "mtaxi",
      active: [
        "match",
        ["to-string", ["get", "type"]],
        "1",
        "trolleybusActive",
        "2",
        "busActive",
        "3",
        "tramActive",
        "4",
        "mtaxiActive",
        "busActive"
      ],
      default: "bus"
    },
    colors: {
      1: "#2e93fe",
      2: "#59D64E",
      3: "#ffac00",
      4: "#B33EA9",
      default: "#777"
    },
    fields: {
      type: "type"
    }
  },
  "12ff4f13-bb98-43c8-bd34-d69808b72c5d": {
    icons: {
      default: "bulldozer-1"
    },
    colors: {
      default: "#2e93fe"
    },
    fields: {
      type: "type"
    }
  },
  "7fc1a76e-84e7-44b7-aed0-b3df8b04b867": {
    icons: {
      default: "bulldozer-1"
    },
    colors: {
      default: "#2e93fe"
    },
    fields: {
      location: "name",
      contact: "contact",
      period: "period"
    }
  },
  "f07ce2e2-253a-4ed7-9529-463b1b2ff1ad": {
    icons: {
      active: "cameraActive",
      default: "camera"
    },
    colors: {
      default: "#59D64E"
    },
    fields: {
      Комплекс: "Комплекс",
      "Канал связи": "Канал связи"
    }
  },
  "tagil-detectors": {
    icons: {
      default: "camera"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      default: "#59D64E"
    }
  },
  "track/telemetry.track_data?format=last_tracks": {
    icons: {
      active: "carActive",
      default: "car"
    },
    colors: {
      default: "#59D64E"
    },
    fields: {
      reg_number: "reg_number",
      name: "name",
      uid: "uid"
    }
  },
  chsmeo_wialon_tracks: {
    icons: {
      active: "bulldozerActive",
      default: "bulldozer-2"
    },
    colors: {
      stroimekhanizatsiya: "#e41a1c",
      stroytech: "#377eb8",
      ural_syberian_company: "#4daf4a",
      stroi_servis: "#a65628",
      default: "#59D64E"
    },
    fields: {
      type: "organization",
      organization: "organization",
      reg_number: "name"
    }
  },
  chsmeo_cams: {
    icons: {
      active: "cameraActive",
      default: "camera"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      inactive: "#999999",
      default: "#59D64E"
    },
    fields: {
      location: "title",
      pdk_cams: "pdk_cams"
    }
  },
  chsmeo_cams_kps: {
    icons: {
      active: "cameraActive",
      default: "camera"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      default: "#59D64E"
    },
    fields: {
      location: "name",
      pdk_cams: "kps_cams"
    }
  },
  "https://lenobl.ritm3.ru/xml_server_results/?limit=10": {
    icons: {
      active: "cameraActive",
      default: "camera"
    },
    colors: {
      default: "#59D64E"
    },
    fields: {}
  },
  "8560fe75-49b2-432a-8494-eab530c8fc4e": {
    icons: {
      active: "cameraActive",
      default: "camera"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      inactive: "#999999",
      default: "#59D64E"
    },
    fields: {
      address: "адрес",
      name: "name",
      camera_id: "camera_id"
    }
  },
  "db258075-aaf2-43c3-85da-065834afada3": {
    icons: {
      active: "cameraActive",
      default: "camera"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      inactive: "#999999",
      default: "#59D64E"
    },
    fields: {
      address: "адрес",
      name: "name",
      camera_id: "camera_id"
    }
  },
  events: {
    icons: {
      ДТП: "road-accident",
      "Ремонтные работы": "road-work",
      Мероприятия: "road-event",
      active: [
        "match",
        ["to-string", ["get", "event_class_id"]],
        "ДТП",
        "roadAccidentActive",
        "Ремонтные работы",
        "roadWorkActive",
        "Мероприятия",
        "roadEventActive",
        "roadEventActive"
      ],
      default: "s-center-editor"
    },
    colors: {
      ДТП: "#FF3E3E",
      "Ремонтные работы": "#ffa931",
      Мероприятия: "#ffee00",
      default: "#FF3E3E"
    },
    fields: {
      type: "event_class_id"
    }
  },
  "http://192.168.88.69:10262/api/ritm": {
    icons: {
      road: "road-accident",
      work: "road-work",
      events: "road-event",
      active: [
        "match",
        ["to-string", ["get", "type"]],
        "road",
        "roadAccidentActive",
        "work",
        "roadWorkActive",
        "events",
        "roadEventActive",
        "roadEventActive"
      ],
      default: "s-center-editor"
    },
    colors: {
      road: "#FF3E3E",
      work: "#ffa931",
      events: "#ffee00",
      default: "#FF3E3E"
    },
    fields: {
      type: "type"
    }
  },
  chsmeo_tlt7: {
    icons: {
      active: "tlt7Active",
      default: "tlt7"
    },
    colors: {
      default: "rgb(255, 113, 0)"
    },
    fields: {
      location: "name"
    }
  },
  podd: {
    icons: {
      default: "podd"
    },
    colors: {
      default: "#59D64E"
    },
    fields: {
      name: "name"
    }
  },
  "podd-dornadzor-layer": {
    icons: {
      default: "podd"
    },
    colors: {
      default: "#59D64E"
    },
    fields: {
      name: "name"
    }
  },
  "podd-dorconsulting-layer": {
    icons: {
      default: "podd"
    },
    colors: {
      default: "#59D64E"
    },
    fields: {
      name: "name"
    }
  },
  event_stat: {
    icons: {
      accident: "road-accident",
      road_works: "road-work",
      events: "road-event",
      default: "road-event"
    },
    colors: {
      accident: "#FF3E3E",
      road_works: "#ffa931",
      events: "#ffee00",
      default: "#FF3E3E"
    }
  },
  track_layer: {
    icons: {
      default: "line"
    },
    colors: {
      default: "#2e93fe"
    },
    fields: {
      avg_speed: "avg_speed",
      to_time: "to_time",
      from_time: "from_time",
      distance: "distance"
    }
  },
  "count/2600d74b-3842-4311-9aa7-a2d742df36da?field=online": {
    icons: {
      default: "street-light"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      inactive: "#999999",
      default: "#59D64E"
    }
  },
  "count/875c93e3-dc09-41bc-b675-51b7461abca1?field=error_flags": {
    icons: {
      default: "traffic-lights"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      inactive: "#999999",
      default: "#59D64E"
    }
  },
  "2600d74b-3842-4311-9aa7-a2d742df36da": {
    icons: {
      active: "streetLightActive",
      default: "street-light"
    },
    colors: {
      default: "#59D64E"
    },
    fields: {
      address: "name",
      status: "online"
    }
  },
  "875c93e3-dc09-41bc-b675-51b7461abca1": {
    icons: {
      active: "trafficLightsActive",
      default: "traffic-lights"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      inactive: "#999999",
      default: "#59D64E"
    },
    fields: {
      location: "description",
      phase: "phase"
    }
  },
  "fe19e836-9559-4834-9f3d-722001dd3dbf": {
    icons: {
      active: "meteostationActive",
      default: "meteostation"
    },
    colors: {
      default: "#59D64E"
    },
    fields: {
      pdk_name: "pdk_name"
    }
  },
  "f4695c7a-4a9c-41fe-84fe-88fb6fb2b2a3": {
    icons: {
      active: "meteostationActive",
      default: "meteostation"
    },
    colors: {
      default: "#999999"
    },
    fields: {
      pdk_name: "pdk_name"
    }
  },
  "TagilPublicTransport?format=vehicles": {
    icons: {
      active: [
        "match",
        ["to-string", ["get", "code"]],
        "299",
        "busActive",
        "300",
        "tramActive",
        "busActive"
      ],
      "Автобус ": "bus",
      Трамвай: "tram",
      default: "bus"
    },
    colors: {
      "Автобус ": "#59D64E",
      Трамвай: "#ffac00",
      default: "#59D64E"
    },
    fields: {
      type: "name",
      "Гос.номер": "reg_number",
      "Модель ТС": "vehicle_model"
    }
  },
  "TagilDetector?format=stats": {
    icons: {
      default: "camera"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      inactive: "#999999",
      default: "#59D64E"
    }
  },
  TagilDetector: {
    icons: {
      active: "cameraActive",
      default: "camera"
    },
    colors: {
      work: "#59D64E",
      error: "#FF3E3E",
      inactive: "#999999",
      default: "#59D64E"
    },
    fields: {
      status: "is_active"
    }
  },
  tagil_matrix_lines: {
    icons: {
      default: "heatmap"
    },
    colors: {
      default: "#59D64E"
    },
    fields: {
      Корреспонденций: "value"
    }
  },
  tagil_rt_stops_point_active: {
    icons: {
      default: "bus"
    },
    colors: {
      default: "#59D64E"
    },
    fields: {
      Остановка: "name",
      Маршрут: "title"
    }
  },
  tagil_rt_routes_lines: {
    icons: {
      default: "line"
    },
    colors: {
      default: "#2e93fe"
    },
    fields: {
      Маршрут: "title"
    }
  },
  default: {
    icons: {
      active: "carActive",
      default: "car"
    },
    colors: {
      default: "#777"
    },
    fields: {
      name: "name"
    }
  }
};

export const getWidgetStyleConfig = layer_id => {
  return widgetStyleConfig[layer_id] || widgetStyleConfig.default;
};
